// src/services/HrmDeviceService.js
import axios from 'axios';
import { AXIOS_BASE_URL } from '@/security/Axios';

const api = axios.create({ baseURL: AXIOS_BASE_URL });

const cfg = (headers) => (headers && Object.keys(headers).length ? { headers } : {});

/** GET /api/hrm-devices */
export async function listHrmDevices(headers = {}) {
  const res = await api.get('/hrm-devices', cfg(headers));
  return res.data;
}

/** POST /api/hrm-devices */
export async function createHrmDevice(payload, headers = {}) {
  const res = await api.post('/hrm-devices', payload, cfg(headers));
  return res.data;
}

/** PUT /api/hrm-devices/:id */
export async function updateHrmDevice(id, payload, headers = {}) {
  const res = await api.put(`/hrm-devices/${id}`, payload, cfg(headers));
  return res.data;
}

/** DELETE /api/hrm-devices/:id */
export async function deleteHrmDevice(id, headers = {}) {
  const res = await api.delete(`/hrm-devices/${id}`, cfg(headers));
  return res.data;
}

/** POST /api/hrm-devices/:id/toggle */
export async function toggleHrmDevice(id, headers = {}) {
  const res = await api.post(`/hrm-devices/${id}/toggle`, {}, cfg(headers));
  return res.data;
}

export default {
  listHrmDevices,
  createHrmDevice,
  updateHrmDevice,
  deleteHrmDevice,
  toggleHrmDevice,
};
